
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DashboardCoreFooter extends Vue {

  private links: Array<{ href: string, text: string }> = [
    {
      href: '#',
      text: 'Creative Tim',
    },
    {
      href: '#',
      text: 'About Us',
    },
    {
      href: '#',
      text: 'Blog',
    },
    {
      href: '#',
      text: 'Licenses',
    },
  ];
}
